import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import type { StandardThumbProps } from '../types';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import TierPromotionCard from '../../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../../TierPromotionCardWithFellaTooltip';
import { getBiDataForTierLink } from '../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import Overlay from '../../legos/Overlay';
import s from './Tier.scss';

const Tier: React.FC<StandardThumbProps> = ({
  deviation,
  width,
  height,
  className,
  responsive,
  style,
  showTierPromotionTooltip,
  extraActions,
  onRemove,
}) => {
  const { t } = useTranslation();
  const a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
  const biData = getBiDataForTierLink(deviation);

  const { showOverlay, __forceHoveredForStories } = useOverlayContext(deviation);

  return (
    <HoverableWrapper
      style={{
        width,
        height,
        ...style,
      }}
      className={classnames(s['root'], className)}
      __forceHoveredForStories={__forceHoveredForStories}
    >
      {showTierPromotionTooltip ? (
        <TierPromotionCardWithFellaTooltip deviation={deviation} width={width} height={height} />
      ) : (
        <TierPromotionCard
          deviation={deviation}
          width={width}
          height={height}
          verticalLayout={responsive}
        />
      )}
      <BiLink
        className={s['link-overlay']}
        biData={biData}
        aria-label={a11yLabel}
        href={Url.userSubscriptionsPath({
          username: deviation.author!.username,
          tierDeviationId: deviation.deviationId,
          tierContentType: 'deviations',
        })}
      >
        <span />
      </BiLink>
      {showOverlay && (
        <Overlay
          deviation={deviation}
          width={width}
          height={height}
          className={s['overlay']}
          extraActions={extraActions}
          aria-hidden="true"
          onRemove={onRemove}
        />
      )}
    </HoverableWrapper>
  );
};
Tier.displayName = 'TierThumb';

export default Tier;
